import React from 'react';
import { X } from 'lucide-react';
import { BusinessOfferBooking } from '../../../types/graphql';

interface TravelersListProps {
  booking: BusinessOfferBooking;
  onClose: () => void;
}

export default function TravelersList({ booking, onClose }: TravelersListProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Liste des voyageurs</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          {booking.travelerInfo.map((traveler, index) => (
            <div key={index} className="p-4 bg-gray-50 rounded-lg">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Nom</p>
                  <p className="font-medium">{`${traveler.firstName} ${traveler.lastName}`}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Email</p>
                  <p className="font-medium">{traveler.email}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Téléphone</p>
                  <p className="font-medium">{traveler.phone}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t">
          <h4 className="font-medium mb-2">Préférences de chambre</h4>
          <div className="space-y-2">
            {booking.roomPreferences.map((room, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span>{room.type}</span>
                <span className="font-medium">{room.count}x</span>
              </div>
            ))}
          </div>
        </div>

        {booking.specialRequests && (
          <div className="mt-4 pt-4 border-t">
            <h4 className="font-medium mb-2">Demandes spéciales</h4>
            <p className="text-sm text-gray-600">{booking.specialRequests}</p>
          </div>
        )}
      </div>
    </div>
  );
}